import { FileType } from './constants/common'

export interface ViewLineImage {
  id: string
  src: string
  label: string
  order?: number
}

export interface FloorImage {
  id: string
  src: string
  label: string
  order?: number
}

export interface PropertyGallery {
  id: string
  src: string
  label: string
  type: FileType
  noSpliceUrl: boolean
  thumbnail?: string
  gradiant?: number
  order?: number
}

interface PropertyGalleryParams {
  projectId: string
  floorImages: Array<FloorImage>
  viewLineImages: Array<ViewLineImage>
  propertyGalleries: Array<PropertyGallery>
  onlyShowPropertyGallery: boolean
}

export const NO_IMAGE_OBJECT: PropertyGallery = {
  id: 'no-image',
  src: '',
  label: 'No Image',
  type: FileType.Image,
  noSpliceUrl: false,
}

const getFloorImageGallery = (
  hash: string,
  floorImages: Array<FloorImage>
): Array<PropertyGallery> =>
  floorImages.map((item) => {
    const src = `/${hash}/floorplans/preview/${item.src}`

    return {
      id: item.id,
      src,
      label: item.label || '',
      type: FileType.Image,
      noSpliceUrl: true,
      thumbnail: src,
      gradiant: 0,
      order: item.order,
    }
  })

const getViewLineGallery = (
  projectId: string,
  viewLineImages: Array<ViewLineImage>
): Array<PropertyGallery> =>
  viewLineImages.map((item) => {
    const src = `/${projectId}/views/${item.src}`
    return {
      id: item.id,
      src,
      label: item.label || '',
      type: FileType.Image,
      noSpliceUrl: true,
      thumbnail: src,
      gradiant: 0,
      order: item.order,
    }
  })

const getPropertyGallery = (
  propertyGalleries: Array<PropertyGallery>
): Array<PropertyGallery> =>
  propertyGalleries.map((item) => {
    const gradiant = item.type === FileType.Video ? 0.5 : 0
    return { ...item, gradiant, noSpliceUrl: item.noSpliceUrl || false }
  })

const mapPropertyGallery = ({
  projectId,
  floorImages,
  viewLineImages,
  propertyGalleries,
  onlyShowPropertyGallery,
}: PropertyGalleryParams): Array<PropertyGallery> => {
  if (!onlyShowPropertyGallery) {
    return [
      ...(floorImages.length
        ? getFloorImageGallery(projectId, floorImages)
        : []),
      ...(viewLineImages.length
        ? getViewLineGallery(projectId, viewLineImages)
        : []),
      ...(propertyGalleries.length
        ? getPropertyGallery(propertyGalleries)
        : []),
    ]
  }

  if (!propertyGalleries.length) {
    return [
      ...getFloorImageGallery(projectId, floorImages),
      ...getViewLineGallery(projectId, viewLineImages),
    ]
  }

  const propertyGalleryItems = getPropertyGallery(propertyGalleries)
  return propertyGalleryItems.length ? propertyGalleryItems : [NO_IMAGE_OBJECT]
}

export default mapPropertyGallery
